module.exports = __webpack_public_path__ + "img/img8.a51b4636.svg";